import { observer } from 'mobx-react-lite';
import { EditPage } from 'src/components/FormPages/EditPage';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { SettingsLandingStore } from 'src/stores/SettingsStores/SettingsLandingStore/SettingsLandingStore';

export const LandingPageEdit = observer(() => {
    return (
        <EditPage
            store={SettingsLandingStore}
            pageName="landing-page-edit"
            baseUrl={RoutePaths.settingsLandingPage}
        />
    );
});
